import {
  AdminSelect,
  AdminSingleLocationPicker,
  Div,
  Icon,
  lightTheme,
  SimpleLocationEntity,
  X,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';
import {
  SYSTEM_PROBLEM_VIEWS,
  SystemProblemView,
} from '../helpers/systemProblemLabels';
import { FilterGrid } from './SystemProblemFilters.styled';

/**
 * "No location filter", as something the picker can hold. The shared picker
 * selects the first location it loads whenever it holds nothing, which on a
 * filter would quietly hide every other location's problems.
 */
export const ALL_LOCATIONS = {
  id: 0,
  name: 'All locations',
} as SimpleLocationEntity;

type Props = {
  view: SystemProblemView;
  onViewChange: (view: SystemProblemView) => void;
  /** The open count, for the Open option. */
  openCount: number;
  location: SimpleLocationEntity;
  setLocation: Dispatch<SetStateAction<SimpleLocationEntity>>;
  /** Fires when a location is actually picked, which is what hits the URL. */
  onLocationPicked: (location: SimpleLocationEntity | null) => void;
};

/**
 * Whose problems, and in which state. How urgent and of which kind are the
 * counters and chips above it, so they are not repeated here as selects.
 */
export const SystemProblemFilters = ({
  view,
  onViewChange,
  openCount,
  location,
  setLocation,
  onLocationPicked,
}: Props) => (
  <FilterGrid>
    <Div $flex $alignCenter $gap="8px" $minWidth="0">
      <Div $width="100%">
        <AdminSingleLocationPicker
          selectedLocation={location}
          setSelectedLocation={
            setLocation as Dispatch<SetStateAction<SimpleLocationEntity | null>>
          }
          handleSubmit={onLocationPicked}
        />
      </Div>

      {/* The picker itself has no way back to everything. */}
      {location.id !== ALL_LOCATIONS.id && (
        <Icon
          $pointer
          $size="16"
          title="Show every location"
          onClick={() => {
            setLocation(ALL_LOCATIONS);
            onLocationPicked(null);
          }}
        >
          <X fill={lightTheme.darkGray} />
        </Icon>
      )}
    </Div>

    <AdminSelect
      value={view}
      onChange={(event) =>
        onViewChange(event.target.value as SystemProblemView)
      }
      $shadowDesign
      options={
        <>
          {SYSTEM_PROBLEM_VIEWS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.value === 'open'
                ? `${option.label} (${openCount})`
                : option.label}
            </option>
          ))}
        </>
      }
    />
  </FilterGrid>
);
